var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(this.article ? this.article.title : this.$route.meta.title))]),(_vm.article)?_c('div',{staticClass:"markdown mx-0 mt-4 dynamic-content",domProps:{"innerHTML":_vm._s(_vm.article.content)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }